
export const getDataLayer = (): any[] => {
    if(!(window as any).dataLayer){
        (window as any).dataLayer = [];
        return (window as any).dataLayer;
    }
    return (window as any).dataLayer;
}